/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    EXCHANGE_ORDER_SUMMARY_INITIALIZE: "exchangeOrderSummary/EXCHANGE_ORDER_SUMMARY_INITIALIZE",
    EXCHANGE_ORDER_SUMMARY_INITIALIZED: "exchangeOrderSummary/EXCHANGE_ORDER_SUMMARY_INITIALIZED",
    CLEAR_EXCHANGE_ORDER_SUMMARY: "exchangeOrderSummary/CLEAR_EXCHANGE_ORDER_SUMMARY",
    EXCHANGE_ORDER_SUMMARY_CHANGE_QTY: "exchangeOrderSummary/EXCHANGE_ORDER_SUMMARY_CHANGE_QTY",
    EXCHANGE_ORDER_SUMMARY_CHANGE_CASE_QTY: "exchangeOrderSummary/EXCHANGE_ORDER_SUMMARY_CHANGE_CASE_QTY",
};

const initialState = {
    isLoading: false,
    data: {},
    error: null
};

export const exchangeOrderSummary = (state = initialState, action) => {
    switch (action.type) {
        case types.EXCHANGE_ORDER_SUMMARY_INITIALIZE:
            return {
                ...state,
                isLoading: true
            };

        case types.EXCHANGE_ORDER_SUMMARY_INITIALIZED:
            return {
                ...state,
                isLoading: false,
                data: action.payload.data
            };

        case types.EXCHANGE_ORDER_SUMMARY_CHANGE_QTY:
            let { id, count, isChanged } = action.payload;
            /* piece added with minQty and case added, while piece decreased as 0 make case as 0 to equal mincount in case */
            let caseCount = action.payload.case_count === 0 ? 0 : state.data[id].case_count;
            count = count === undefined ? state.data[id].count : count;
            return {
                ...state,
                data: { ...state.data, [id]: { ...state.data[id], count, isChanged, case_count: caseCount } }
            };

        case types.EXCHANGE_ORDER_SUMMARY_CHANGE_CASE_QTY:
            let { product_id, case_count, caseChange } = action.payload;
            case_count = case_count === undefined ? state.data[product_id].case_count : case_count;

            return {
                ...state,
                data: { ...state.data, [product_id]: { ...state.data[product_id], case_count, isChanged: caseChange } }
            };

        case types.CLEAR_EXCHANGE_ORDER_SUMMARY:
            return {
                ...initialState
            };

        default:
            return state;
    }
};

/* Clear exchange return summary on every exchange return load */
export const clearExchangeOrderSummary = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.CLEAR_EXCHANGE_ORDER_SUMMARY });
    }
};

export const exchangeOrderSummaryChangeQty = payload => {
    return {
        type: types.EXCHANGE_ORDER_SUMMARY_CHANGE_QTY,
        payload
    };
};

export const exchangeOrderSummaryChangeCaseQty = payload => {
    return {
        type: types.EXCHANGE_ORDER_SUMMARY_CHANGE_CASE_QTY,
        payload
    };
};

export const initializeExchangeOrderSummary = (productPayload) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: types.EXCHANGE_ORDER_SUMMARY_INITIALIZE });

            let initState = {};
            let responseProducts = [];
            const summaryData = getState().exchangeOrderSummary.data;

            productPayload.ids.forEach(id => { responseProducts.push(productPayload.data[id]); });

            responseProducts.forEach((p) => {
                let count = 0;
                let case_count = 0;
                let isChanged = false;

                /* Check for product already added */
                if (summaryData[p.ProductId] !== undefined) {
                    count = summaryData[p.ProductId].count;
                    case_count = summaryData[p.ProductId].case_count;
                    isChanged = summaryData[p.ProductId].isChanged;
                }

                initState[p.ProductId] = {
                    PId: p.ProductId,
                    count,
                    case_count,
                    isChanged,
                    conversionQty: p.ConversionQty,
                    PrincipalId: p.PrincipalId,
                    DiscountId: p.DiscountId,
                    SchemeId: p.SchemeId,
                    productName: p.ProductName,
                    price: p.BuyPrice.toFixed(2),
                    DistributorId: p.DistributorId,
                    UomId: p.UomId
                };
            });

            /* Merge old and new product state */
            const updatedState = { ...summaryData, ...initState }

            dispatch({ type: types.EXCHANGE_ORDER_SUMMARY_INITIALIZED, payload: { data: updatedState } });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, "", true));
        }
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({ type: type, payload: { error: message } });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};